import { render } from "./CodeBlockComponent.vue?vue&type=template&id=7a38f2bc"
import script from "./CodeBlockComponent.vue?vue&type=script&lang=js"
export * from "./CodeBlockComponent.vue?vue&type=script&lang=js"

import "./CodeBlockComponent.vue?vue&type=style&index=0&id=7a38f2bc&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__